module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-backplates.c989b4bd.png";